import { constants, publicEncrypt } from 'crypto-browserify';

export const encryptData = (data: string, publicKey: string): string => {
  const buffer = Buffer.from(data, 'utf8');
  const encrypted = publicEncrypt(
    {
      key: publicKey,
      padding: constants.RSA_PKCS1_OAEP_PADDING
    },
    buffer
  );
  return encrypted.toString('base64');
};
